import { Button, Stack, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DownloadIcon from '@mui/icons-material/Download';
import type { CalendarLinks as CalendarLinksType } from '../../api/client';

// ─── Types ───────────────────────────────────────────────────────────────────

interface CalendarLinksProps {
  links: CalendarLinksType;
}

// ─── Component ───────────────────────────────────────────────────────────────

export default function CalendarLinks({ links }: CalendarLinksProps) {
  return (
    <Stack spacing={1.5} sx={{ width: '100%' }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600 }}>
        Add to your calendar
      </Typography>

      <Button
        variant="contained"
        size="large"
        fullWidth
        startIcon={<CalendarMonthIcon />}
        href={links.google}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ justifyContent: 'flex-start', py: 1.2 }}
      >
        Add to Google Calendar
      </Button>

      <Button
        variant="outlined"
        size="large"
        fullWidth
        startIcon={<CalendarMonthIcon />}
        href={links.outlook}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ justifyContent: 'flex-start', py: 1.2 }}
      >
        Add to Outlook
      </Button>

      <Button
        variant="outlined"
        size="large"
        fullWidth
        startIcon={<DownloadIcon />}
        href={links.ics}
        sx={{ justifyContent: 'flex-start', py: 1.2 }}
      >
        Download .ics file
      </Button>
    </Stack>
  );
}
